import React from "react";

import Styles from "./BoxTitle.module.css";

const BoxTitle = (props) => {

  return (
    <div className={Styles["boxTitle"]}>
      <div className="row">
        <div className={`col-xs-12 ${Styles["title"]}`}>{props.title}</div>
      </div>
    </div>
  );
};

export default BoxTitle;
